/**
 * Redux Action utils module
 * @module: utils/reduxAction
 * @exports: makeActionCreator, dispatchAction
 */

/**
 * Generates a function that creates an action creator
 * @param {string} type - action type the action creator passes to the reducer
 * @param {Array} argNames - Any other arguments the action creator passes to the reducer
 * @returns {function} the action creator
 * @exports makeActionCreator
 */
export function makeActionCreator(type, ...argNames) {
	return function(...args) {
		let action = { type };
		argNames.forEach((arg, index) => {
			action[argNames[index]] = args[index];
		});
		return action;
	};
}

/**
 * Generates a function that dispatches a Redux action
 * @param {function} dispatch - Redux dispatch function
 * @param {object} action - Action object to dispatch
 * @returns {function} Function that dispatches a Redux action
 * @exports dispatchAction
 */
export function dispatchAction(dispatch, action){
	return function() {
		dispatch(action);
	};
}



// WEBPACK FOOTER //
// ../~/dna-core/components/utils/js/reduxActions.js